import api from "../../features/auth/axiosConfig";
import { Theme } from "../modules/profile/types/profile";

/** Fetch theme list from backend */
export const getTheme = async (): Promise<Theme[]> => {
  const response = await api.get(`/pos/v2/theme`);
  return response.data.result;
};

/** Update theme in backend */
export const updateThemeApi = async (newTheme: Theme): Promise<Theme> => {
  const response = await api.put(`/pos/v2/theme`, newTheme);
  return response.data; // assuming backend returns updated theme
};
